import { useInfiniteQuery } from '@tanstack/react-query';
import { pick } from 'lodash';

import { getNextPageParam, groupsCacheKeys, useGroupsFilterParams } from '@pkg/hooks';

import { Groups } from '@app/client';

/**
 * React Hook using React Query to call `/groups/collections`.
 */
export const useGetGroupsCollections = (names?: string) => {
    const groupsFilterParams = useGroupsFilterParams();
    const baseFilters = { ...pick(groupsFilterParams.filters, ['spam']) };
    const collectionsFilters = names ? { filters: { ...baseFilters, names } } : { filters: baseFilters };
    const cache = [groupsCacheKeys.groupsCollections(collectionsFilters), names];

    return useInfiniteQuery(
        cache,
        ({ pageParam = 0, signal }) =>
            Groups.callGetGroupsCollections({
                query: { page: pageParam || 0, limit: 6, ...collectionsFilters.filters },
                settings: { signal },
            }),
        {
            retry: false,
            keepPreviousData: true,
            getNextPageParam,
        },
    );
};
